import { jsx as m } from "react/jsx-runtime";
import { d as l } from "../../vendor-Dd6qj6gJ.js";
import { forwardRef as r } from "react";
import { stupidInvertClasses as d } from "../../utils/index.js";
import { BaseIcon as p } from "../BaseIcon/index.js";
import { omitStyleRenderProps as u } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index15.css';const h = "_moon_1hsta_1", i = "_red_1hsta_5", g = "_sienna_1hsta_9", f = "_gold_1hsta_13", I = "_cactus_1hsta_17", x = "_green_1hsta_21", b = "_teal_1hsta_25", C = "_blue_1hsta_29", v = "_purple_1hsta_33", R = "_magenta_1hsta_37", j = "_sm_1hsta_41", w = "_md_1hsta_45", y = "_calloutIcon_1hsta_49", t = {
  moon: h,
  red: i,
  sienna: g,
  gold: f,
  cactus: I,
  green: x,
  teal: b,
  blue: C,
  purple: v,
  magenta: R,
  sm: j,
  md: w,
  calloutIcon: y
}, z = {
  md: "xl",
  sm: "lg"
}, q = r(
  ({ icon: n, color: o = "moon", __inverted: a, size: s = "md", ..._ }, c) => {
    const e = l(
      t.calloutIcon,
      t[o],
      t[s],
      a ? d() : void 0
    );
    return /* @__PURE__ */ m(
      p,
      {
        ...u(_),
        "data-component": "CalloutIcon",
        ref: c,
        icon: n,
        size: z[s],
        color: o,
        className: e
      }
    );
  }
);
export {
  q as CalloutIcon
};
